export const addToTableFilter = (prevState, itemId, optionId) => {
  // if category is found, and option is selected, unselect it
  if (prevState[itemId] && prevState[itemId].includes(optionId)) {
    return { ...prevState, [itemId]: prevState[itemId].filter((option) => option !== optionId) };
  }

  return { ...prevState, [itemId]: !prevState[itemId] ? [optionId] : [...prevState[itemId], optionId] };
};
